import request from '../utils/request'
import teacherRequest from '../utils/teacherRequest'

export default {
  computed: {
    isTeacherMode() {
      return !!(this.$route.meta && this.$route.meta.teacherMode)
    },
    api() {
      return this.isTeacherMode ? teacherRequest : request
    },
    apiPrefix() {
      return this.isTeacherMode ? '/api/teacher' : '/api/admin'
    }
  }
}
